import React from 'react'

const AcercaDe = () => {
  return (
    <div>AcercaDe</div>
  )
}

export default AcercaDe